export enum ChangeScanModeResponse {
  Success = 1,
  Error = 2,
  WallboxNotConnected = 3,
  FreechargeIsActive = 4
}
